import { mutatePositions } from '../../mutations/mutatePositions';
import { organizationAPI } from 'api/phases/endpoints';
import { serialize } from 'object-to-formdata';

export const addPosition = async (name: string) => {
  const formData = serialize({ position: { name } });
  await organizationAPI.addPosition(formData);
  await mutatePositions();
};
